// Copyright ©️ 2026 eVolve MEP, LLC

import type { SavedGridStateJsonString } from '@evolvemep/api-ts';
import type { GridState } from 'ag-grid-enterprise';

import { getSavedGridState } from 'helpers/ag-grid/TableViewPanel/getSavedGridState';
import type { SavedGridState } from 'helpers/ag-grid/TableViewPanel/types';

export const parseGridStateJson = (jsonString: SavedGridStateJsonString) => {
  if (!jsonString.trim()) return null;
  try {
    return JSON.parse(jsonString) as SavedGridState;
  } catch (error) {
    // oxlint-disable-next-line no-console
    console.error('Failed to parse grid state JSON string:', error);
    return null;
  }
};

export const stringifyGridStateJson = (gridState: GridState) => {
  const savedGridState = getSavedGridState(gridState);
  return JSON.stringify(savedGridState) as SavedGridStateJsonString;
};
